



























import {getStationName, trainStore} from '@/data/train-store';
import AppBase from '../components/AppBase.vue';
import {Component, Vue} from 'vue-property-decorator';
import {Observer} from 'mobx-vue';
import TrainRideLine from '@/components/TrainRideLine.vue';

@Observer
@Component({
  components: {AppBase, TrainRideLine}
})
export default class SearchResults extends Vue {
  private results = trainStore.search.results;

  private get nearestMatchIndex() {
    if (!this.results) return NaN;

    const [closestRide] = this.rides.slice(0)
      .sort((a, b) => Math.abs(a.minutesFromSearch) - Math.abs(b.minutesFromSearch));

    return this.rides.indexOf(closestRide);
  }

  get rides() {
    if (!this.results) return [];
    return this.results.rides.filter((ride) => {
      return !(ride.minutesFromSearch > 120 || ride.minutesFromSearch < -120);
    });
  }

  get fromStation() {
    if (!this.results) return '';
    return getStationName(this.results.params.fromId);
  }

  get toStation() {
    if (!this.results) return '';
    return getStationName(this.results.params.toId);
  }

  get date() {
    if (!this.results) return '';
    const date = new Date(this.results.params.date);
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
  }

  public created() {
    if (!this.results) {
      this.$router.push('/search');
    }
  }

  public mounted() {
    const scrollWrapper = this.$refs.scrollWrapper as HTMLElement;
    if (!scrollWrapper) return;
    const scrollParent = scrollWrapper.parentNode as HTMLElement;
    const bestRideEl = (this.$refs.bestRide as any)[0].$refs.element as HTMLElement;
    if (!scrollParent || !bestRideEl) return;
    const yOffset = Math.max(bestRideEl.offsetTop - (scrollWrapper.offsetHeight / 2), 0);
    scrollWrapper.scroll(0, yOffset);
  }

  private getLineBackground(minutesFromSearch: number) {
    if (minutesFromSearch < 10 && minutesFromSearch > -10) {
      // damn close!
      return 'hsla(39, 100%, 82%, 1)';
    } else if (minutesFromSearch < 30 && minutesFromSearch > -20) {
      // pretty close
      return 'hsla(39, 100%, 88%, 1)';
    } else if (minutesFromSearch < 60 && minutesFromSearch > 0) {
      // around
      return 'hsla(39, 100%, 94%, 1)';
    }

    // none
    return 'none';
  }
}
